<template>
  <el-dialog title="转单" :visible.sync="formVisible" :close-on-click-modal="false" width="900px">
    <el-form ref="dataForm" label-position="right" :rules="formRules" :model="form" size="small" label-width="100px">
      <el-form-item label="带教老师：" prop="technicianInfoId" class="width100">
        <el-select v-model="form.technicianInfoId" :placeholder="`请选择`" clearable filterable >
          <el-option :label="`${item.realName} (${item.mobile})(${item.levelName})`" :value="item.id" v-for="item in techOption" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注：" prop="remark" class="width100">
        <el-input v-model="form.remark" :placeholder="`请输入备注`" type="textarea" :rows="3" maxlength="500" show-word-limit />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import technicalManageApi from '@/api/technical/technicianInfo'
import technicianServiceOrderApi from '@/api/technical/technicianServiceOrder'
import { debounce } from 'lodash';
function initFormBean() {
  const formBean = {
    id: null,
    technicianInfoId: null,
    remark: '',
  }
  return formBean
}

export default {
  data() {
    return {
      form: initFormBean(),
      isLoading: false,
      formVisible: false,
      formRules: {
        technicianInfoId: [{ required: true, message: '请选择带教老师', trigger: 'change' }]
      },
      techOption: []
    }
  },
  created() {
    this.getTechOption()
    // this.debouncedGetTechOption = debounce(this.getTechOption, 300)
  },
  methods: {
    resetForm() {
      this.form = initFormBean()
    },
    async getTechOption(e) {
      // let obj = { pageNo: 1, pageSize: 1000, realName: e, levelIsBigCustomer: true,status: 10 }
      let obj = { pageNo: 1, pageSize: 1000, realName: e, status: 10, levelIsOrdinary: true }
      const { data } = await technicalManageApi.listPageForMini(obj)
      this.techOption = data.list
    },

    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form.id = row.id;
      this.form.technicianInfoId = row.technicianInfoId;
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true
          let params = { ...this.form }
          technicianServiceOrderApi.updateServiceTech(params).then((data) => {
            this.postCallback(data)
          }).catch(res => {
            this.isLoading = false
          });
        }
      });
    },
    postCallback(data) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
      this.isLoading = false
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-cascader {
  width: 100%;
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
</style>
